import { render, staticRenderFns } from "./HarjoituksetTable.vue?vue&type=template&id=d7b2bdf8"
import script from "./HarjoituksetTable.vue?vue&type=script&lang=js"
export * from "./HarjoituksetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports